// ambil pesan error dari response upload (axios error atau response statusCode != 200)
function getUploadErrorMessage(err) {
  const fallback = "Upload gagal, silakan coba lagi"

  if (err?.isAxiosError) {
    if (err.response?.status === 413) return "File too big"
    return err.response?.data?.message || fallback
  }

  return err?.message || fallback
}

export default getUploadErrorMessage
